import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-office', 'BrandOffice', [["path",{"d":"M4 18h9v-12l-5 2v5l-4 2v-8l9 -4l7 2v13l-7 3l-9 -3","key":"svg-0"}]]);